import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionDefinition, OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

import { Messages } from '../../../codegen/Localize';
import { OrderKeys } from '../../../spacesPlatform/models/OrderKeys';

const workbookCountSortOption: OptionDefinition = {
  id: 'workbooks',
  getMenuItemDisplayValue: Messages.column_numWorkbooks,
  subSortOptions: {
    'desc': {
      id: 'workbooks.desc',
      field: OrderKeys.connectedWorkbooksCount,
      getMenuItemDisplayValue: Messages.sortByMostLeast,
      getButtonDisplayValue: Messages.sortByNumWorkbooksDesc,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.connectedWorkbooksCount), Order.asc(OrderKeys.name)]
    },
    'asc': {
      id: 'workbooks.asc',
      field: OrderKeys.connectedWorkbooksCount,
      getMenuItemDisplayValue: Messages.sortByLeastMost,
      getButtonDisplayValue: Messages.sortByNumWorkbooksAsc,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.connectedWorkbooksCount), Order.asc(OrderKeys.name)]
    }
  }
};

const dependentDatasourcesCountSortOption: OptionDefinition = {
  id: 'dependentdatasourcescount',
  getMenuItemDisplayValue: Messages.column_numDependentDatasources,
  subSortOptions: {
    'desc': {
      id: 'dependentdatasourcescount.desc',
      field: OrderKeys.dependentDataSourcesCount,
      getMenuItemDisplayValue: Messages.sortByMostLeast,
      getButtonDisplayValue: Messages.sortByNumDependentDatasourcesDesc,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.dependentDataSourcesCount), Order.asc(OrderKeys.name)]
    },
    'asc': {
      id: 'dependentdatasourcescount.asc',
      field: OrderKeys.dependentDataSourcesCount,
      getMenuItemDisplayValue: Messages.sortByLeastMost,
      getButtonDisplayValue: Messages.sortByNumDependentDatasourcesAsc,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.dependentDataSourcesCount), Order.asc(OrderKeys.name)]
    }
  }
};

// for searching, only
export const isCertifiedSortOption: OptionDefinition = {
  id: 'isCertified.desc',
  field: OrderKeys.isCertified,
  getMenuItemDisplayValue: () => Messages.sortByIsCertified(),
  getButtonDisplayValue: () => Messages.sortByIsCertified(),
  ascending: false,
  toOrderClauseArray: () => [{field: OrderKeys.isCertified, ascending: false}]
};

export const datasourceSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'hits': SortOptions.hits,
  'workbooks': workbookCountSortOption,
  'dependentdatasourcescount': dependentDatasourcesCountSortOption,
  'containerName': SortOptions.containerName,
  'owner': SortOptions.owner,
  'refresh': SortOptions.datasourceRefresh,
  'updated': SortOptions.updated,
  'modifiedBy':  SortOptions.modifiedBy,
  'alert': SortOptions.alert
};

export const datasourceSortOptionsForSearch: OptionsDictionary = {
  'isCertified': isCertifiedSortOption,
  ...datasourceSortOptions
};


